import axiosInstance from "../lib/axiosInstance";

const baseUrl = process.env.REACT_APP_API_URL + "/tag";

const tagModel = class {

  async getAlltags() {
    return (await axiosInstance.get(`${baseUrl}/getAllRequestedTag`)).data;
  }
  async addTagToExperienceOptions(data) {
    return (await axiosInstance.post(`${baseUrl}/experience-options/add-tag`, data)).data;
  }
  async deleteTagRequest(id) {
    return (await axiosInstance.delete(`${baseUrl}/tags/${id}`)).data;
  }
};

export default new  tagModel();
